import { api } from "../../../api/axiosInstance";
import type { SingpassOnboardVerificationRequest } from "../ts";

export const sitterAPI = {
  getMyinfoUrl() {
    return api.get("/api/v1/sitters/singpass/");
  },
  onboardSingpass(request: { code: string; state: string }) {
     return api.post("/api/v1/sitters/singpass/", request);
  },
  onboardVerification(request: SingpassOnboardVerificationRequest) {
    return api.post("/api/v1/sitters/singpass/verification/", request);
  }
};
